module.exports = __webpack_public_path__ + "static/img/web_icon.2bdcc38e.png";